var React = require('react');

function IcClose24px (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"}));
}

IcClose24px.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = IcClose24px;

IcClose24px.default = IcClose24px;
